import React, {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './daily.css'
const Privacy = (props:any) =>{
    useEffect(()=>{
      window.scroll(0,0)
    },[])
    const { item } =
    (props.location && props.location.state) || {};
    console.log(item)

    return (
        <div className="App">
            <div className="daily">
            <h2 id='隐私政策'>隐私政策</h2>
<p>更新日期：2021年7月19日</p>
<p>生效时间：2021年7月19日</p>
<p>开发者名称：中坤鼎昊（北京）国际商务服务有限公司</p>
<p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。 请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</p>
<h3 id='一收集用户个人信息手段'><strong>一、收集用户个人信息手段</strong></h3>
<p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 我们仅会出于本政策所述的以下目的，收集和使用您的个人信息： 开展内部数据分析和研究，第三方SDK统计服务，改善我们的产品或服务，我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集的数据可能包括SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEI）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。</p>
<h3 id='二我们如何共享转让公开披露您的个人信息'>二、我们如何共享、转让、公开披露您的个人信息</h3>
<p>（1）我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
<ul>
<li>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
<li>我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
<li>与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 我们的关联公司包括:【请填入关联公司名称】。</li>
<li>与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，我们聘请来提供第三方数据统计和分析服务的公司可能需要采集和访问个人数据以进行数据统计和分析。在这种情况下，这些公司 必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。 对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</li>

</ul>
<p>（2） 我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
<ul>
<li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
<li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>

</ul>
<p>（3）我们仅会在以下情况下，公开披露您的个人信息：</p>
<ul>
<li>获得您明确同意后；</li>
<li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>

</ul>
<p>当您与我们联系时，我们可能会保存与您的通信内容或您留下的联系方式，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
<h3 id='三我们如何保护您的个人信息'>三、我们如何保护您的个人信息</h3>
<p>（1）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受 SSL 加密保护；我们同时对我们网站提供 https 安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
<p>（2）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
<p>（3）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
<p>（4）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
<p>（5）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。 同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
<h3 id='四我们如何处理儿童的个人信息'>四、我们如何处理儿童的个人信息</h3>
<p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。 对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。 尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。 如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
<h3 id='五我们如何使用-cookie-和同类技术'>五、我们如何使用 Cookie 和同类技术</h3>
<p>（1）Cookie 为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。 我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</p>
<p>（2）网站信标和像素标签 除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</p>
<p>（3）Do Not Track（请勿追踪） 很多网络浏览器均设有 Do Not Track 功能，该功能可向网站发布。</p>
<h3 id='六第三方sdk情况说明'>六、<strong>第三方SDK情况说明</strong></h3>
<p>我们移动应用内嵌使用了第三方软件工具开发包（SDK），我们会对授权合作伙伴获取有关信息的应用程序接口（API）、第三方SDK进行严格的安全监测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。部分第三方SDK可能会调用或获取您的相关信息。我们将这些第三方SDK的名称、使用目的、官网链接以及收集个人信息类型列明如下：</p>
<p><strong>极光推送</strong></p>
<p>使用目的：用于实现手机APP消息推送</p>
<p>收集个人信息类型：设备信息</p>
<p>官网链接：<a href='https://www.jiguang.cn/' target='_blank' >https://www.jiguang.cn/</a></p>
<p>隐私政策链接：<a href='https://www.jiguang.cn/license/privacy'>https://www.jiguang.cn/license/privacy</a></p>

            </div>
        </div>
    );
}

export default Privacy;
